import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReferralCommentsWidgetComponent } from './referral-comments-widget.component';
import { FuseWidgetModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { DataGridModule } from 'app/components/data-grid/data-grid.module';
import { TranslationControlsComponentModule } from 'app/components/translation-controls/translation-controls.module';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';
import { PhoenixPipesModule } from 'app/pipes/pipes';

@NgModule({
    declarations: [
        ReferralCommentsWidgetComponent,
    ],
    imports: [
        FuseWidgetModule,
        FuseSharedModule,
        CommonModule,
        MatDividerModule,
        MatInputModule,
        MatFormFieldModule,
        MatButtonModule,
        MatMenuModule,
        FormsModule,
        MatIconModule,
        MatToolbarModule,
        MatTooltipModule,
        DataGridModule,
        TranslationControlsComponentModule,
        PhoenixDirectivesModule,
        PhoenixPipesModule
     ],
    exports: [
        ReferralCommentsWidgetComponent,

    ],
    providers: [],
})
export class ReferralCommentsWidgetModule {}
